export const UPDATE_BREADCRUMBS = "UPDATE_BREADCRUMBS";
export const UPDATE_NAVBAR = "UPDATE_NAVBAR";
export const GENERIC_ERROR = "GENERIC_ERROR";

export const FILTER_RESULTS = "FILTER_RESULTS";
export const SET_FILTER_LOCATION = "SET_LOCATION";
export const SET_HAZARD = "SET_HAZARD";
export const SET_ANALYSISTYPE = "SET_ANALYSISTYPE";
export const SET_STARTYEAR = "SET_STARTYEAR";
export const SET_ENDYEAR = "SET_ENDYEAR";
export const ERROR_SET_FILTER = "ERROR_SET_FILTER";

export const GET_RESULTS = "GET_RESULTS";
export const SET_RESULTS = "SET_RESULTS";
export const SET_FILTERED_RESULTS = "SET_FILTERED_RESULTS";
export const RESET_FILTERED_RESULTS = "RESET_FILTERED_RESULTS";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const SET_RENDERED_RESULTS = "SET_RENDERED_RESULTS";
export const ERROR_RESULTS = "ERROR_RESULTS";
export const GET_SEARCH_RESULTS = "GET_SEARCH_RESULTS";
export const SEARCH_BUSY = "SEARCH_BUSY";
export const SEARCH_NOTBUSY = "SEARCH_NOTBUSY";
export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
export const SET_FILTER_ECONOMIC_LOSS_MIN = "SET_FILTER_ECONOMIC_LOSS_MIN";
export const SET_FILTER_ECONOMIC_LOSS_MAX = "SET_FILTER_ECONOMIC_LOSS_MAX";

export const GET_STATES = "GET_STATES";
export const GET_COUNTIES = "GET_COUNTIES";
export const GET_CITIES = "GET_CITIES";
export const SET_STATES = "SET_STATES";
export const SET_COUNTIES = "SET_COUNTIES";
export const SET_CITIES = "SET_CITIES";
export const FILTER_LOCATIONS = "FILTER_LOCATIONS";
export const SET_STATE_SELECTED = "SET_STATE_SELECTED";
export const SET_COUNTY_SELECTED = "SET_COUNTY_SELECTED";
export const SET_CITY_SELECTED = "SET_CITY_SELECTED";

export const GET_STUDY = "GET_STUDY";
export const GET_GEOM = "GET_GEOM";
export const GET_ANALYSES = "GET_ANALYSES";
export const GET_DOWNLOADS = "GET_DOWNLOADS";
export const ADD_ANALYSIS_GEOM = "ADD_ANALYSIS_GEOM";
export const REMOVE_ANALYSIS_GEOM = "REMOVE_ANALYSIS_GEOM";
export const ERROR_DETAILS = "ERROR_DETAILS";
export const SORT_ANALYSES_BY_DATE = "SORT_ANALYSES_BY_DATE";
export const SORT_ANALYSES_BY_ALPHA = "SORT_ANALYSES_BY_ALPHA";
export const SORT_ANALYSES_BY_ECONOMIC_LOSSES_HIGH_TO_LOW =
  "SORT_ANALYSES_BY_ECONOMIC_LOSSES_HIGH_TO_LOW";
export const SORT_ANALYSES_BY_ECONOMIC_LOSSES_LOW_TO_HIGH =
  "SORT_ANALYSES_BY_ECONOMIC_LOSSES_LOW_TO_HIGH";
export const CLEAR_DETAILS = "CLEAR_DETAILS";
